module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icon-action-8f82e9a77921181cdf0ce0a43cd40838.svg";